import React, {createContext, useEffect, useState, ReactNode, Context} from "react";
import {data} from "react-router-dom";

const ActivityContext = createContext<IActivityContext> ({} as IActivityContext);

export interface IAvatar{
    "color": string,
    "image": string,
    "image2": string,
    "halo": string,
    "alt": string,
    "ariaLabel": string,
    "width": string | number,
    "height": string | number,
    haloWidth : number,
    haloHeight : number
}

export interface IActivity{
    "title": string,
    "skills": string[],
    "image": string,
    "editable" ?: boolean,
    "selectedSkill"?: string
}

export interface IPosition{
    x : number,
    y : number,
    parentWidth : number,
    parentHeight : number
}

export interface IResolvedActivity{
    activity : IActivity,
    position : IPosition,
    r : number
    scale: number;
}

interface IActivityContext {
    avatar : IAvatar | null,
    setAvatar : React.Dispatch<React.SetStateAction<IAvatar | null>>
    setCurrentActivityResolved : React.Dispatch<React.SetStateAction<boolean>>
    currentActivity : number,
    nextActivity : Function,
    currentActivityResolved : boolean,
    resolveActivity : (activity : IResolvedActivity) => void,
    resolvedActivity : IResolvedActivity | null,
    resolvedActivities : IResolvedActivity[],
    moveToResolved : Function,
    sendData : Function
}
interface IActivityContextProps {
    children: ReactNode | ReactNode[];
}

function ActivityContextProvider(props : IActivityContextProps) {

    const [ avatar  , setAvatar ] = useState<IAvatar |null >(null);
    const [ currentActivity  , setCurrentActivity ] = useState<number >(0);
    const [ currentActivityResolved  , setCurrentActivityResolved ] = useState<boolean >(false);
    const [ resolvedActivity  , setResolvedActivity] = useState<IResolvedActivity | null >(null);
    const [ resolvedActivities  , setResolvedActivities] = useState<IResolvedActivity[] >([]);

    const nextActivity = () => {
        setCurrentActivity(currentActivity + 1);
        setCurrentActivityResolved(false);
        moveToResolved()
    }

    const resolveActivity = (activity : IResolvedActivity) =>{
        setCurrentActivityResolved(true);
        setResolvedActivity(activity)
    }


    const moveToResolved = () =>{
        resolvedActivity &&resolvedActivities.push(resolvedActivity);
        setResolvedActivities(resolvedActivities);
        setResolvedActivity(null);
    }

    useEffect(() => {

    }, []);

    const sendData = () =>{
        console.log('send data')
        fetch('public/response.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(resolvedActivities)
        }).then((resp)=> resp.json()).then((data) =>{
            console.log(data)
        })
    }

    return (
        <ActivityContext.Provider value={{
            avatar, setAvatar,
            currentActivity, nextActivity,
            currentActivityResolved, resolveActivity, resolvedActivity ,setCurrentActivityResolved,
            resolvedActivities, moveToResolved,
            sendData
        }}>
            {props.children}
        </ActivityContext.Provider>
    )

}

export { ActivityContextProvider };
export default ActivityContext;